<template>
  <div id="app" :class="{'union-root': inMicroApp}">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      pageType: ''
    }
  },
  computed: {
    ...mapGetters(['inMicroApp'])
  },
  beforeCreate () {
    let hash = window.location.hash
    if (hash === '#/') {
      if (window.location.href.indexOf('awards') > 0) {
        this.$router.push({
          path: '/rightsList'
        })
      } else {
        let activityId = this.$utils.getUrlParam(window.location.href, 'activityId')
        let applyId = this.$utils.getUrlParam(window.location.href, 'applyId') || -1
        let minAmount = this.$utils.getUrlParam(window.location.href, 'minAmount')
        if (typeof activityId !== 'undefined') {
          this.$router.push({
            path: '/' + activityId + '/' + applyId,
            query: {
              minAmount
            }
          })
        } else {
          this.$router.push({
            name: 'home'
          })
        }
      }
    }
  }
}
</script>
<style>
.union-root {
  background: #fff;
}
.union-root .jdm-title {
  font-size: 18px !important;
  font-weight: bold !important;
  line-height: 26px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue